import Image from "next/image";

type SvgProps = {
  name: string;
  alt: string;
  width: number;
  height: number;
  className?: string;
  fill?: string;
  isColored?: boolean;
};

export const SvgWeb = ({
  name,
  alt,
  className,
  width,
  height,
  fill,
  isColored = false,
}: SvgProps) => {
  return (
    <Image
      src={
        isColored
          ? `/images/svg/svg_colors/${name}.svg`
          : `/images/svg/${name}.svg`
      }
      alt={alt}
      loading="lazy"
      className={className}
      width={0}
      height={0}
      style={{
        width: width,
        height: "auto",
      }}
    />
  );
};
